import { isString, unary } from "lodash";
import { FunctionId, UntypedArrayId } from "../../../typing/typing";

import { FunctionType, ListType, ModusPonens } from "../Types";
import { Constructors, isExternal, unboxExternal, getExternalObjType, Reduction } from "../Lambda";
import { isPureList } from "./Lists";
var C = Constructors;

/**
 * Constructor of functions over lists.
 * Technically ListFunction constructs an External object of ListFunction type.
 * 
 * Let `f` be a function that takes an array as a single argument,
 * `telm` be type of each element, `tres` be a type of a result.
 * `ListFunction(f, telm, tres)` is then a lambda term which,
 * when applied to a {@link EInstances/Lists List object}
 * consiting of External elements,
 * unwraps them and passes to `f`.
 *
 * @example
 * Application(ListFunction(f, a, b), PureList([x, y], a))
 *        -> External(f([x, y]), b)
 * 
 * @param {function} f - JS function of array
 * @param {Type} [telm] - type of each element
 * @param {Type} [tres] - type of result
 * @return External term with a type `[telm] -> tres`
 * @memberof module:EInstances
 */
function ListFunction(f, telm, tres) {
  f = isString(f) ? "(" + f + ")" : FunctionId(f);
  return new C.External(f, "ListFunction",
           new FunctionType(new ListType(telm), tres));
}

/**
 * Reduction of ListFunction.
 * @member
 * @memberof module:EInstances
 */
function ListFunctionReduction(term, reduce) {
  if(term instanceof C.Application &&
      isExternal(term.func, "ListFunction") &&
        isExternal(term.arg, "List")) {
    var
      f = term.func.object,      // JS function
      l = term.arg.object;  // List term's array
    if(! isPureList(l, term.func.termType.dom.elType)) return undefined;
    var
      a = l.list.map(unary(unboxExternal)),
      r = eval('(' + f + ')')(UntypedArrayId(a)),  // result
      t = ModusPonens(term.func.type(), term.arg.type());
    return new C.External(r, getExternalObjType(t), t);
  }
}

// add to default reductions
Reduction.DefaultReductions.push(ListFunctionReduction);

export default ListFunction;
